import api from "./apiClient";

export const apiGet = async (url, options = {}) => {
    try {
        const { params, ...axiosConfig } = options;

        const response = await api.get(url, {
            params,
            ...axiosConfig,
        });
        return response;
    } catch (error) {
        handleError(error);
        throw error;
    }
};

export const apiPost = async (url, data = {}, config = {}) => {
    try {
        let finalData = data;
        if (typeof data === "string") {
            try {
                const parsed = JSON.parse(data);
                finalData = parsed;
                config.headers = {
                    ...(config.headers || {}),
                    "Content-Type": "application/json"
                };
            } catch {
            }
        }

        const response = await api.post(url, finalData, config);
        return response;

    } catch (error) {
        handleError(error);
        throw error;
    }
};

export const apiPut = async (url, data = {}) => {
    try {
        const response = await api.put(url, data);
        return response;
    } catch (error) {
        handleError(error);
    }
};

export const apiDelete = async (url) => {
    try {
        const response = await api.delete(url);
        return response;
    } catch (error) {
        handleError(error);
    }
};

function handleError(error) {
    if (error.response) {
        console.error("API Error:", error.response.data);

        if (error.response.status === 401) {
            console.log("Unauthorized — redirecting...");
        }
    } else {
        console.error("Network error:", error);
    }

    throw error;
}
